var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-similar px-md-9 px-0"},_vm._l((_vm.news),function(card){return _c('card',{key:card.id,attrs:{"card":card,"max":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }